export const NEW_TEMPLATE_PARAM = 'new';
